import React from "react";
import { ChatPage } from "../../../../app/modules/apps/chat/ChatPage";

export function SidebarGPT() {

  return (
    <>
      {/* begin::Sidebar Content */}
      <div id="kt_sidebar_content" className="py-10 px-5 px-lg-5">
        <div
          className="hover-scroll-y me-lg-n2 pe-lg-2"
          data-kt-scroll="true"
          data-kt-scroll-height="auto"
          data-kt-scroll-offset="10px"
          data-kt-scroll-dependencies="#kt_sidebar_tabs, #kt_sidebar_footer"
          data-kt-scroll-wrappers="#kt_sidebar_content"
        >
          {/* begin::Card */}
          <div className="card card-custom bg-transparent">
            {/* begin::Header */}
            <div className="card-header align-items-center border-0">
              <h3 className="card-title fw-bolder text-white fs-3">
                Get help from AI
              </h3>
            </div>
            {/* end::Header */}

            {/* begin::Body */}
            <div className="card-body px-3 py-0">

              {/* begin::Content*/}
              <div className="flex-lg-row-fluid ms-lg-12" id="kt_chat_content">

              <ChatPage />

              </div>
              {/* end::Content*/}

            </div>
            {/* end: Card Body */}
          </div>
          {/* end::Card */}

        </div>
      </div>
      {/* end::Sidebar Content */}

      {/* begin::Sidebar footer */}
      <div id="kt_sidebar_footer" className="py-2 px-5 pb-md-6 text-center">
        <button
          type="button"
          className="btn btn-color-white bg-white bg-opacity-10 bg-hover-opacity-20 fw-bolder w-100"
        >
          View Extended Layout
        </button>
      </div>
      {/* end::Sidebar footer */}
    </>
  );
}

